import Vue from 'vue'

Vue.filter('removeSpecialChars', function(value) {
  return removeSpecialChars(value)
})

export const removeSpecialChars = value => {
  if (!value) {
    return ''
  }

  value = value.toString()
  return (
    value
      //.trimRight()
      .toLowerCase()
      .replace(/ö+/g, 'oe')
      .replace(/ü+/g, 'ue')
      .replace(/ä+/g, 'ae')
      // .normalize('NFD')
      // .replace(/[\u0300-\u036f]/g, '') //umlaute ä > a
      .replace(/&+/g, 'und') //&
      .replace(/ß+/g, 'ss') //&
      .replace(/\s+/g, '-')
      .trim()
  )
}
